import React from 'react';
import { motion } from 'framer-motion';
import Reveal from './Reveal';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import { useLanguage } from '../lib/LanguageContext';

const Journal = () => {
  const { language } = useLanguage();
  const labels = language === 'ro'
    ? { eyebrow: 'News & Jurnal', heading: 'Cele mai recente', all: 'Toate articolele', read: 'Citește' }
    : { eyebrow: 'News & Journal', heading: 'Latest stories', all: 'All stories', read: 'Read' };
  const entries = posts.slice(0, 3);
  return (
    <section
      id="journal"
      className="bg-bone text-charcoal py-24 md:py-32 lg:py-40 border-t border-charcoal"
      data-testid="journal-section"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <div className="flex items-end justify-between gap-6 mb-14 md:mb-20">
          <Reveal>
            <div>
              <span className="text-[11px] tracking-eyebrow uppercase text-charcoal/60">
                {labels.eyebrow}
              </span>
              <h2
                className="mt-5 font-sans font-extrabold text-charcoal leading-[0.95] tracking-normal text-5xl md:text-6xl lg:text-7xl"
                data-testid="journal-heading"
              >
                {labels.heading}
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="hidden md:block">
            <Link to="/journal" className="editorial-link" data-testid="journal-all-link">
              <span>{labels.all}</span>
              <span className="arrow">→</span>
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 lg:gap-12">
          {entries.map((entry, i) => {
            const content = entry[language] || entry.en;
            return <motion.div
              key={entry.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              className="group flex flex-col"
              data-testid={`journal-card-${i}`}
            >
              <Link to={`/journal/${entry.slug}`} className="group flex h-full flex-col">
              <div className="relative w-full aspect-[5/6] overflow-hidden bg-beige">
                <img
                  src={entry.cover}
                  alt={content.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]"
                  style={{ filter: 'grayscale(0.3)' }}
                />
              </div>
              <div className="mt-6 flex items-center justify-between text-[11px] tracking-eyebrow uppercase text-charcoal/60">
                <span>{entry.type}</span>
                <span>{entry.date[language]}</span>
              </div>
              <h3
                className="mt-4 font-sans font-extrabold text-3xl md:text-4xl leading-[1.05] text-charcoal group-hover:opacity-70 transition-opacity duration-500"
              >
                {content.title}
              </h3>
              <p className="mt-4 text-[14px] md:text-[15px] text-charcoal/70 leading-relaxed font-bold">
                {content.excerpt}
              </p>
              <span className="editorial-link mt-6 self-start">
                <span>{labels.read}</span>
                <span className="arrow">→</span>
              </span>
              </Link>
            </motion.div>;
          })}
        </div>
      </div>
    </section>
  );
};

export default Journal;
